
import React,{useContext, useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom';
import './paginationComponent.css';

function TinyPaginationComponent({ page, itemContext, item }) {
    
    const {count: pages} = useContext(itemContext);
    const [pageNumber, setPageNumber] = useState(1);
    const navigate = useNavigate();

    useEffect(() => {
        if (parseInt(page) <= parseInt(pages) - 3) {
            setPageNumber(parseInt(page));
        } else {
            setPageNumber(parseInt(pages) - 3)
        }
    }, [page, pages])

    function onclickNext() {
        if (page < pages) {
            navigate(`/${item}/${parseInt(page) + 1}`)
        }
    }

    function onclickPrevious() {
        if (page > 1) {
            navigate(`/${item}/${parseInt(page) - 1}`)
        }
    }

    return (
        
        <div className="pagination">
        {
            <div className="pagination-content">
                <span onClick={onclickPrevious}>
                    <i className="fa-solid fa-angle-left"></i>
                </span>

                <span onClick={() => navigate(`/${item}/${1}`)} > Premier </span>
                <span className='page-number-active'>{page}/{pages} </span>
                <span onClick={() => navigate(`/${item}/${pages}`)} > Dernier </span>

                <span onClick={onclickNext} >
                    <i className="fa-solid fa-angle-right"></i>
                </span>
            </div>
        }
    </div>


    )
}

export default TinyPaginationComponent
